export default __webpack_public_path__ + "static/media/ticket_it.859e3d57.png";